import React, { TextareaHTMLAttributes } from "react";

export interface TextareaProps
  extends TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className = "", children, rows = 4, ...args }, ref) => {
    return (
      <textarea
        ref={ref}
        className={`block w-full text-sm rounded-xl border-neutral-500 focus:border-pink-500 focus:ring-0 focus:ring-primary-200 focus:ring-opacity-50 bg-white dark:border-neutral-700 dark:focus:border-pink-500 dark:focus:ring-opacity-25 dark:bg-neutral-900 ${className}`}
        rows={rows}
        {...args}
        placeholder="Enter your Message..."
      >
        {children}
      </textarea>
    );
  }
);

export default Textarea;
